import { defineStore } from 'pinia'
import { store } from '../index'
import { useCache } from '@/hooks/web/useCache'

const { wsCache } = useCache()

interface AppState {
  fixedMenu: boolean
  role: string
  userInfo: any
  clickStatus: boolean
  summaryTable: any
  managerClassTable: any
  isInitialized: boolean
}

export const useAppStore = defineStore('app', {
  state: (): AppState => {
    return {
      fixedMenu: false, // 是否固定菜单
      role: '', // 角色
      userInfo: {}, // 登录信息存储字段
      clickStatus: false, // 是否点击
      summaryTable: {},
      managerClassTable: {},
      isInitialized: false, // 标记是否已初始化
    }
  },
  getters: {
    getFixedMenu(): boolean {
      return this.fixedMenu
    },
    getRole(): string {
      return this.role
    },
    getUserInfo(): any {
      return this.userInfo
    },
    getClickStatus(): boolean {
      return this.clickStatus
    },
    getSummaryTable(): any {
      return this.summaryTable
    },
    getManagerClassTable(): string {
      return this.managerClassTable
    }
  },
  actions: {
    // 初始化store数据
    async initializeStore() {
      if (this.isInitialized) return
      
      try {
        const [fixedMenu, role, userInfo, summaryTable, managerClassTable] = await Promise.all([
          wsCache.get('fixedMenu'),
          wsCache.get('role'),
          wsCache.get('userInfo'),
          wsCache.get('summaryTable'),
          wsCache.get('managerClassTable')
        ])

        this.fixedMenu = fixedMenu || false
        this.role = role || ''
        this.userInfo = userInfo || {}
        this.summaryTable = summaryTable || {}
        this.managerClassTable = managerClassTable || ''
        this.isInitialized = true
      } catch (error) {
        console.error('Failed to initialize store:', error)
        this.isInitialized = true // Still mark as initialized to prevent infinite waiting
      }
    },
    
    async setFixedMenu(fixedMenu: boolean) {
      await wsCache.set('fixedMenu', fixedMenu)
      this.fixedMenu = fixedMenu
    },
    async setRole(role: string) {
      await wsCache.set('role', role)
      this.role = role
    },
    async setUserInfo(userInfo: any) {
      await wsCache.set('userInfo', userInfo)
      this.userInfo = userInfo
    },
    setClickStatus(clickStatus: boolean) {
      this.clickStatus = clickStatus
    },
    async setSummaryTable(summaryTable: any) {
      await wsCache.set('summaryTable', summaryTable)
      this.summaryTable = summaryTable
    },
    async setManagerClassTable(managerClassTable: string) {
      await wsCache.set('managerClassTable', managerClassTable)
      this.managerClassTable = managerClassTable
    },
    
    // 清除所有数据
    async clearStore() {
      this.fixedMenu = false
      this.role = ''
      this.userInfo = {}
      this.clickStatus = false
      this.summaryTable = {}
      this.managerClassTable = ''
      this.isInitialized = false
    }
  }
})

export const useAppStoreWithOut = () => {
  return useAppStore(store)
}